import classNames from "classnames";
// React
import React from "react";
import { Link } from "react-router";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class PageTab extends React.Component {
    render() {
        const { url, label } = this.props;
        return (React.createElement("li", null,
            React.createElement(Link, { activeClassName: "active", className: classNames(""), to: url }, label)));
    }
}
